
import Vue from "vue";
import SolicitudArrendamientoService from '@/services/SolicitudArrendamientoService';
import {mapGetters} from "vuex";
import CustomFile from "@/components/Common/CustomFile.vue";
import { _solicitudArrendamiento, solicitudArrendamiento } from "@/models/solicitudArrendamiento";
import FormCreate from "@/components/Solicitudes/FormSolicitudArrendamiento.vue";
import FormContrato from "@/components/Solicitudes/FormContratoArrendamiento.vue";
import { CatalogoService } from "@/services/CatalogoService";
import EstablecimientoService from '@/services/EstablecimientoService';

export default Vue.extend({
    name: "Establecimientos",
    mixins: [],
    components: {CustomFile,FormCreate,FormContrato
    },
    directives: {},
    data: () => ({
      listEstatus: [
      {
        id:15,
        descripcion:"PENDIENTE"
      },
      {
        id:3,
        descripcion:"VALIDADA"
      },
      {
        id:10,
        descripcion:" EN REVISION"
      }
    ],
    documentoview: Document || null,
     dialogPdfView:false,
      showInputPagoSolid:false,
      dialogsubirdoc:false,
      dialogCreateContrato: false,
      servicio:new CatalogoService('SolicitudArrendamiento'),
      element: new solicitudArrendamiento(),
      dialogCreate: false,
      filters: {
            page: 1,
            external_id: "",
            nombre_comercial: "",
            id_estatus:0,
            per_page: 10,
        },
        pagination: {
            from: 1,
            last_page: 1,
        },
        list: [],
    }),
    mounted() {
        this.getData();
    },
    computed: {
        ...mapGetters({
            usuario: "usuario",
            id: "id",
            contribuyente: "contribuyente",
            mini: "sidebar",
        }),
    },
    watch: {
        "filters.page": function () {
            this.getData();
            //this.saveFilters();
        },
    },
    methods: {
      openDialogPagoSolid(item: any){
          this.element = item;
          this.dialogsubirdoc = true;
          if(item.id_recibo_pago > 0){
            this.showInputPagoSolid = false;
          }
        },
      async viewpdf(item: any, tipo:any,id:any,titulo:any) {
        const response = await EstablecimientoService.descargarFormato(`documentacion/${id}`,{},'GET','Temp');

        let file = new Blob([response.data],{type: response.headers['content-type']});
        const url = window.URL.createObjectURL(file);
          this.documentoview = {
            //@ts-ignore
            title: titulo,
            url: url,
            mime: response.headers['content-type'],
            tipo: tipo,
            datos:item
        }
        this.dialogPdfView=true;
    },
      closeDialogAutorizacion() {
          this.dialogsubirdoc = false;
        },
      subirDocPago(item:any){
          var valor = 0;
          if(item.id_recibo_pago >0){
            valor = item.id_recibo_pago;
          }
          let data = {
            docSolidPago: item.docSolidPago,
            id_recibo_pago: valor
            };
            SolicitudArrendamientoService.subirArchivoSolidPago(item.id, data)
                .then((response) => {
                    if (response.data.success) {
                        this.$toast.success(response.data.message);
                        this.closeDialogAutorizacion();
                        this.getData();
                    } else {
                        this.$toast.error(response.data.message);
                    }
                })
                .catch((error) => {
                    this.$toast.error("No se pudo guardar el archivo.")
                })
        },
      setDocument(e: any, type: number) {
            const fileReader = new FileReader();
            fileReader.addEventListener("load", () => {
                var file = fileReader.result;
                if (type == 1)
                //@ts-ignore
                this.element.docSolidPago = file + "";
        });
        if (e != null)
        fileReader.readAsDataURL(e);
        },
        cancelChangeFile(file: any) {
      if (file == 1)
        this.showInputPagoSolid = false;
    },
    changeFile(file: any) {
        if (file == 1)
        this.showInputPagoSolid = true;
    },
      clearFilters() {
      this.filters = {
        page: 1,
        id_estatus: 0,
        nombre_comercial: '',
        external_id: '',
        per_page: 10
      }
      this.getData();
    },
      setEstatus(){
      this.filters = {
        ...this.filters,
        id_estatus: this.listEstatus.find((item: any) => item.id == this.filters.id_estatus)!.id
      }
    },
        async getData() {
            if (!this.filters.page) {
                this.filters.page = 1;
            }

        if (this.filters.external_id || this.filters.nombre_comercial) {
            this.filters.page = 1;
        }
        if (!this.filters.external_id && !this.filters.nombre_comercial) {
            this.filters.external_id = "";
            this.filters.nombre_comercial = "";
        }

        const { data } = await SolicitudArrendamientoService.getall(this.contribuyente.id, this.filters);
                
        this.pagination = {
        from: data.from,
        last_page: data.last_page
            }
               this.list = data.data;
        },
        newItem() {
        this.element = Object.assign({});
        this.dialogCreate = true;
      },
      editar(item: any) {
        this.element = Object.assign({}, item);
        this.dialogCreate = true;
      }, 
      newItemContrato(item: any) {
        this.element = Object.assign({}, item);

        if (this.element.fecha_inicio != null) {
          const [year, month, day] = this.element.fecha_inicio.split('-')
        const[da,hous] =day.split(' ')
        this.element.fecha_inicio= `${year}-${month}-${da}`
        } 

        if (this.element.fecha_fin != null){
          const [year2, month2, day2] = this.element.fecha_fin.split('-')
        const[da2,hous2] =day2.split(' ')
        this.element.fecha_fin= `${year2}-${month2}-${da2}`
        }

        this.dialogCreateContrato = true;
      },
      editarContrato(item: any) {
        this.element = Object.assign({}, item);
        this.dialogCreateContrato = true;
      }, 
      closeDialogCreate(reload:boolean){
          this.dialogCreate = false;
      if(reload)
        this.getData();
      },
      closeDialogCreateContrato(reload:boolean){
          this.dialogCreateContrato = false;
      if(reload)
        this.getData();
      },
      validarSolicitud(item: any) {
        SolicitudArrendamientoService.validarSolicitud(item.id)
                .then((response) => {
                    if (response.data.success) {
                        this.$toast.success(response.data.message);
                        this.getData();
                    } else {
                        this.$toast.error(response.data.message);
                    }
                })
                .catch((error) => {
                    this.$toast.error("No se pudo enviar la solicitud.")
                })
      },
      validarContrato(item: any) {
        SolicitudArrendamientoService.validarContrato(item.id)
                .then((response) => {
                    if (response.data.success) {
                        this.$toast.success(response.data.message);
                        this.getData();
                    } else {
                        this.$toast.error(response.data.message);
                    }
                })
                .catch((error) => {
                    this.$toast.error("No se pudo enviar la solicitud.")
                })
      },  
       
    },
});
